import React, { useEffect, useRef, useState } from 'react';
// security.css in 432 to 574 
const TrustStatement = () => {
  // State to track scroll progress (0 to 1)
  const [scrollProgress, setScrollProgress] = useState(0);
  
  // References to DOM elements we want to animate
  const sectionRef = useRef(null);
  const titleWordsRef = useRef([]);
  const descriptionRef = useRef(null);
  const topLineRef = useRef(null);
  const bottomLineRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      // Agar section exist nahi karta, toh return
      if (!sectionRef.current) return;

      // Section ki position calculate karo
      const sectionTop = sectionRef.current.offsetTop;
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      
      // Scroll distance - kitne pixels mein animation complete hoga
      const scrollDistance = 400; // 400px scroll karne par animation complete
      
      // Progress calculate karo (0 se 1 ke beech)
      // Formula: (current scroll - section start + half window) / distance
      let progress = (scrollY - sectionTop + windowHeight / 2) / scrollDistance;
      
      // Progress ko 0 aur 1 ke beech limit karo
      progress = Math.max(0, Math.min(1, progress));
      
      // State update karo
      setScrollProgress(progress);

      // ----- AB DIFFERENT ELEMENTS KO ANIMATE KARTE HAIN -----
      
      // 1. Title ke words ko ek-ek karke show karna
      const totalWords = titleWordsRef.current.length;
      const wordsToShow = Math.floor(progress * totalWords);
      
      titleWordsRef.current.forEach((word, index) => {
        if (!word) return;
        
        if (index < wordsToShow) {
          // Visible words
          word.classList.remove('faded');
          word.classList.add('visible');
        } else {
          // Hidden words
          word.classList.remove('visible');
          word.classList.add('faded');
        }
      });
      
      // 2. Description text ko fade in karna (0.3 progress ke baad)
      if (descriptionRef.current) {
        if (progress > 0.3) {
          descriptionRef.current.classList.add('visible');
        } else {
          descriptionRef.current.classList.remove('visible');
        }
      }
      
      // 3. Top line ko animate karna (0.2 progress se start)
      if (topLineRef.current) {
        const lineProgress = Math.max(0, Math.min(1, (progress - 0.2) / 0.3));
        topLineRef.current.style.transform = `scaleX(${lineProgress})`;
      }
      
      // 4. Bottom line ko animate karna (0.6 progress se start)
      if (bottomLineRef.current) {
        const lineProgress = Math.max(0, Math.min(1, (progress - 0.6) / 0.3));
        bottomLineRef.current.style.transform = `scaleX(${lineProgress})`;
      }
    };
    
    // Scroll event listener add karo
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial call for starting position
    
    // Cleanup - jab component unmount ho, toh event listener hata do
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Empty dependency array - sirf ek baar run hoga

  // Title ko words mein todna for animation
  const titleWords = ["Security", "that", "works", "for", "real", "teams"];

  return (
    <section 
      ref={sectionRef} 
      className="security_Real_Time trust-statement-section"
      id="trust-statement"
    >
      <div className="trust-statement-container">
        {/* Top decorative line - animated */}
        <div 
          ref={topLineRef}
          className="trust-line top-line"
          style={{ transform: 'scaleX(0)' }} // Initially hidden
        ></div>
        
        {/* Main content */}
        <div className="trust-content">
          <h2 className="trust-title">
            {/* Words ko individually render karo for animation */}
            {titleWords.map((word, index) => (
              <React.Fragment key={index}>
                <span
                  ref={(el) => (titleWordsRef.current[index] = el)}
                  className={`trust-word ${index === 0 ? 'visible' : 'faded'}`}
                >
                  {word}
                </span>
                {index < titleWords.length - 1 && " "}
              </React.Fragment>
            ))}
          </h2>
          
          {/* Description with fade animation */}
          <p 
            ref={descriptionRef}
            className="trust-description"
          >
            Every day, teams handle deadlines, files, discussions, and sensitive information. 
            Security shouldn't slow you down. Simplifyte keeps your work protected with safe 
            storage, smart access controls, and reliable systems—so you can focus on what matters.
          </p>
        </div>
        
        {/* Bottom decorative line - animated */}
        <div 
          ref={bottomLineRef}
          className="trust-line bottom-line"
          style={{ transform: 'scaleX(0)' }} // Initially hidden
        ></div>
        
        {/* Optional: Scroll indicator */}
        {/* {scrollProgress < 0.9 && (
          <div className="trust-scroll-indicator">
            <span>Scroll to reveal</span>
            <div className="trust-scroll-arrow"></div>
          </div>
        )} */}
      </div>
    </section>
  );
};

export default TrustStatement;